import { createSlice } from "@reduxjs/toolkit";

// Load theme from localStorage or default to 'dark'
const getInitialTheme = () => {
  const savedMode = localStorage.getItem('themeMode');
  return savedMode || 'dark'; // Default to dark mode
};

const getInitialCustomTheme = () => {
  const savedTheme = localStorage.getItem('customTheme');
  return savedTheme || null;
};

const initialState = {
  mode: getInitialTheme(),
  customTheme: getInitialCustomTheme(),
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
      localStorage.setItem('themeMode', state.mode);
    },
    setThemeMode: (state, action) => {
      state.mode = action.payload;
      localStorage.setItem('themeMode', state.mode);
    },
    setTheme: (state, action) => {
      state.customTheme = action.payload.theme;
      localStorage.setItem('customTheme', action.payload.theme);
    },
  },
});

export const { setMode, setThemeMode, setTheme } = themeSlice.actions;
export default themeSlice.reducer;